import { receiptApi } from '../../lib/api';

/** Datei -> reines base64 (ohne `data:...;base64,`-Prefix), wie es die API erwartet. */
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result).split(',')[1] ?? '');
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

/**
 * MIME-Type einer Datei fuer den Upload bestimmen. iOS/Safari liefert bei HEIC
 * oft einen leeren Typ; dann aus der Endung ableiten statt blind 'image/jpeg' zu
 * behaupten (der Server bestimmt den echten Typ ohnehin aus den Magic Bytes,
 * aber ein falsch deklariertes HEIC wuerde als JPEG durchgereicht).
 */
function mimeOf(f: File): string {
  if (f.type) return f.type;
  const ext = f.name.toLowerCase().match(/\.([a-z0-9]+)$/)?.[1];
  switch (ext) {
    case 'heic':
    case 'heif':
      return 'image/heic';
    case 'png':
      return 'image/png';
    case 'webp':
      return 'image/webp';
    case 'avif':
      return 'image/avif';
    case 'gif':
      return 'image/gif';
    case 'tif':
    case 'tiff':
      return 'image/tiff';
    case 'pdf':
      return 'application/pdf';
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    default:
      // Unbekannt -> der Server entscheidet anhand der Magic Bytes.
      return 'application/octet-stream';
  }
}

/**
 * Belege hochladen + KI-Erkennung anstoßen. Gibt die Anzahl angelegter Belege zurück.
 * onProgress meldet den Upload-Fortschritt in Bytes (0..1 berechnet der Aufrufer).
 */
export async function uploadReceiptFiles(
  companyId: string,
  list: File[],
  onProgress?: (sent: number, total: number) => void,
): Promise<number> {
  const files = await Promise.all(
    list.map(async (f) => ({ data: await fileToBase64(f), mime: mimeOf(f) })),
  );
  const r = await receiptApi.upload(companyId, files, onProgress);
  return r.created;
}
